var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-container', [_c('b-row', [_c('b-col', [_c('div', {
    staticClass: "text-grey1 ml-0"
  }, [_vm._v("Book a Test > Diagnostic Centres")]), _c('b-card', {
    staticClass: "text-grey mt-4"
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('p', {
    staticClass: "ml-3 mt-2 distance-filter"
  }, [_vm._v("Filter By Distance")])]), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-form-input', {
    staticClass: "mt-2",
    attrs: {
      "id": "range-1",
      "type": "range",
      "min": "0",
      "max": "10"
    },
    model: {
      value: _vm.value,
      callback: function ($$v) {
        _vm.value = $$v;
      },
      expression: "value"
    }
  })], 1), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('div', {
    staticClass: "mt-2"
  }, [_vm._v("Distance: " + _vm._s(_vm.value) + "km to " + _vm._s(_vm.max) + "km")])]), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-row', [_c('b-form-input', {
    staticClass: "mt-2 col-10 border-radius-left-40",
    attrs: {
      "placeholder": "Search Store..."
    },
    model: {
      value: _vm.storeName,
      callback: function ($$v) {
        _vm.storeName = $$v;
      },
      expression: "storeName"
    }
  }), _c('button', {
    staticClass: "col search-button mt-2 ml-n1 border-radius-r-40",
    on: {
      "click": _vm.storeResult
    }
  }, [_c('b-icon', {
    staticClass: "margin-top-4",
    attrs: {
      "icon": "search"
    }
  })], 1)], 1)], 1)], 1)], 1), _c('div', [_c('sections-slider', {
    staticClass: "pharmacyshop-sec",
    attrs: {
      "list": _vm.pharmacyStore,
      "hasBackground": false,
      "withoutSlider": true
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref) {
        var listItem = _ref.listItem;
        return [_c('div', {
          staticClass: "item-box"
        }, [_c('items-item', {
          attrs: {
            "itemWhite": true,
            "product": listItem,
            "rating": _vm.getProductFeedbackData(listItem._id).ratingAverage || 2.5,
            "marketRoute": {
              name: 'diagnostic-center-detail',
              params: {
                id: listItem._id,
                items: listItem.office.officeName
              }
            }
          }
        })], 1)];
      }
    }])
  })], 1)], 1)], 1), _c('b-row', [_c('b-col', [_c('div', {
    staticClass: "main-banner"
  }, [_c('img', {
    attrs: {
      "src": _vm.diagnosticBanner.icon && _vm.diagnosticBanner.icon.fileUrl || '',
      "alt": "Diagnostic Centers Bottom Banner"
    }
  })])])], 1), _c('b-row', [_c('b-col', [_c('sections-slider', {
    staticClass: "suggested-slider",
    attrs: {
      "list": _vm.itemSuggestions,
      "subTitle": "Recently Searched",
      "showTitle": true,
      "hasBackground": false,
      "hasButton": true,
      "withSlider": true,
      "viewMorePage": {
        name: `health-care-listing`,
        params: {
          items: `Most Popular`
        }
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref2) {
        var listItem = _ref2.listItem;
        return [_c('div', {
          staticClass: "item-box ml-2 mr- 2"
        }, [_c('items-item', {
          staticClass: "suggester-div",
          attrs: {
            "itemNoBg": true,
            "product": listItem,
            "incrementDecrementKey": true
          }
        })], 1)];
      }
    }])
  })], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }